import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// I caratteri viaggiano nel pacchetto (dal 23/09/2026): prima li chiedeva a
// Google un <link> bloccante in index.html, e sul telefono con rete scarsa
// l'app restava scura finche' Google non rispondeva. Solo i pesi usati dal
// tema e solo l'alfabeto latino (con le estese): 14 file da ~25 KB, non 49.
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-ext-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-ext-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-ext-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/inter/latin-ext-700.css";
import "@fontsource/inter-tight/latin-600.css";
import "@fontsource/inter-tight/latin-ext-600.css";
import "@fontsource/inter-tight/latin-700.css";
import "@fontsource/inter-tight/latin-ext-700.css";
import "@fontsource/inter-tight/latin-800.css";
import "@fontsource/inter-tight/latin-ext-800.css";
import "./index.css";
import "yet-another-react-lightbox/styles.css";

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  caches.keys().then((keys) => {
    keys.forEach((key) => caches.delete(key));
  });
}

/**
 * Se la configurazione non e' finita nel bundle, l'app non puo' partire: il
 * client Supabase esplode al caricamento del modulo e resta una pagina bianca,
 * senza niente in console e senza niente a schermo. E' successo il 3 agosto 2026,
 * perche' la build della CI girava senza .env.
 *
 * Una pagina bianca non dice a nessuno cosa e' rotto: ne' all'installatore che ci
 * prova, ne' a chi deve ripararla. Meglio un messaggio.
 */
const radice = document.getElementById("root")!;
const configurazioneMancante =
  !import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (configurazioneMancante) {
  radice.innerHTML = `
    <div style="font-family:system-ui,-apple-system,Segoe UI,sans-serif;max-width:34rem;margin:15vh auto;padding:0 1.5rem;line-height:1.6">
      <h1 style="font-size:1.25rem;margin:0 0 .75rem">Assistente momentaneamente non disponibile</h1>
      <p style="color:#666;margin:0 0 1rem">
        L'applicazione è stata pubblicata senza la sua configurazione e non può
        collegarsi ai dati. Non è un problema del tuo dispositivo.
      </p>
      <p style="color:#666;margin:0">
        Se stai leggendo questo messaggio, segnalalo a
        <a href="mailto:info@b2brand.it" style="color:inherit">info@b2brand.it</a>:
        si ripara con una nuova pubblicazione.
      </p>
    </div>`;
  console.error(
    "[avvio] VITE_SUPABASE_URL o VITE_SUPABASE_PUBLISHABLE_KEY mancanti nel bundle: " +
      "la build e' stata fatta senza .env.production",
  );
} else {
  createRoot(radice).render(<App />);
}

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => console.log("SW registered:", reg.scope))
      .catch((err) => console.error("SW registration failed:", err));
  });
}
